export default __webpack_public_path__ + "static/media/m_multiple_bg.107e36af.png";